export const languages = [
  { code: 'ES', label: 'Español', flag: '🇪🇸', flagCode: 'es', locale: 'es' },
  { code: 'EN', label: 'English', flag: '🇬🇧', flagCode: 'gb', locale: 'en' },
  { code: 'CA', label: 'Català', flag: '🇪🇶', flagCode: 'ad', flagUrl: "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 9 6'%3E%3Crect width='9' height='6' fill='%23fcdd09'/%3E%3Crect y='0.667' width='9' height='0.667' fill='%23da121a'/%3E%3Crect y='2' width='9' height='0.667' fill='%23da121a'/%3E%3Crect y='3.333' width='9' height='0.667' fill='%23da121a'/%3E%3Crect y='4.667' width='9' height='0.667' fill='%23da121a'/%3E%3C/svg%3E", locale: 'ca' },
  { code: 'FR', label: 'Français', flag: '🇫🇷', flagCode: 'fr', locale: 'fr' },
];

import { translationsExtra } from './translationsExtra';

const baseTranslations = {
  ES: {
    // Navbar
    'nav.solutions': 'Soluciones',
    'nav.sectors': 'Tipos de negocios',
    'nav.verifactu': 'VeriFactu',
    'nav.success': 'Casos de Éxito',
    'nav.software': 'Software TPV',
    'nav.hardware': 'Hardware',
    'nav.cashdro': 'Cajones inteligentes',
    'nav.kiosks': 'Quioscos',
    'nav.channels': 'Canales de venta',
    'nav.payments': 'Medios de pago',
    'nav.hospitality': 'Hostelería',
    'nav.retail': 'Retail',
    'nav.food': 'Alimentación',
    'nav.beauty': 'Belleza',
    'nav.franchises': 'Cadenas y Franquicias',
    'nav.demo': 'Demo Gratis',
    'nav.clientArea': 'Área de Cliente',
    'nav.configurator': 'Configurador',
    'nav.analytics': 'Analytics',
    'nav.hioffice': 'HIOffice',
    'nav.support': 'Soporte técnico',
    'nav.manuals': 'Manuales',
    'nav.logout': 'Cerrar sesión',
    'nav.tryFree': 'Pruébalo gratis',
    'nav.skipContent': 'Saltar al contenido',
    'nav.mainNav': 'Navegación principal',
    'nav.selectLanguage': 'Seleccionar idioma',
    'nav.userMenu': 'Menú de usuario',
    'nav.openMenu': 'Abrir menú',
    'nav.closeMenu': 'Cerrar menú',
    'nav.pricing': 'Precios',
    'nav.home': 'Ir a la página de inicio',

    // Hero (título, descripción y cifras: se muestran solo en móvil)
    'hero.title': 'TPV para llevar tu negocio al siguiente nivel',
    'hero.desc2': 'El ecosistema más completo para que vendas más y gestiones mejor.',
    'hero.for': 'Para',
    'hero.stats.businesses': 'negocios activos',
    'hero.stats.uptime': 'uptime garantizado',
    'hero.stats.sales': 'aumento en ventas',
    'hero.stats.cash': 'descuadres de caja',
    'sectors.fashion.name': 'Moda',
    'sectors.shoes.name': 'Zapaterías',
    'sectors.chains.name': 'Cadenas',
    'sectors.franchises.name': 'Franquicias',
    'hero.discoverMore': 'Descubre más',

    // Footer
    'footer.tagline': 'La mejor solución de gestión para tu negocio:',
    'footer.taglineHighlight': 'IA, software, ecommerce, cajones inteligentes, quioscos y servicios integrados',
    'footer.taglineEnd': 'para que crezcas más y mejor!',
    'footer.solutions': 'Soluciones',
    'footer.software': 'Software TPV',
    'footer.hardware': 'Hardware Táctil',
    'footer.cashdro': 'CashDro',
    'footer.kiosks': 'Quioscos',
    'footer.verifactu': 'VeriFactu',
    'footer.configurator': 'Configurador',
    'footer.sectors': 'Sectores',
    'footer.hospitality': 'Hostelería',
    'footer.retail': 'Retail',
    'footer.food': 'Alimentación',
    'footer.beauty': 'Belleza',
    'footer.franchises': 'Cadenas y Franquicias',
    'footer.contact': 'Contacto',
    'footer.rights': 'Todos los derechos reservados.',
    'footer.about': 'Sobre Nosotros',
    'footer.blog': 'Blog',
    'footer.pricing': 'Precios',
    'footer.guide': 'Guía TPV',
    'footer.privacy': 'Privacidad',
    'footer.cookies': 'Cookies',
    'footer.legal': 'Aviso Legal',
    'footer.freeDemo': 'Demo Gratuita',

    // Contact
    'contact.eyebrow': 'Contacto',
    'contact.title1': 'Hablemos de tu',
    'contact.title2': 'próximo proyecto',
    'contact.desc': '¿Quieres ver SmartPOS en acción? Solicita una demo personalizada y sin compromiso. Nuestro equipo te contactará para analizar tu negocio y diseñar la solución a medida.',
    'contact.phone': 'Teléfono',
    'contact.phoneDesc': 'Llámanos y habla directamente con nuestro equipo comercial.',
    'contact.email': 'Email',
    'contact.emailDesc': 'Escríbenos y te respondemos en menos de 24 horas.',
    'contact.office': 'Oficina',
    'contact.officeDesc': 'Av. Lluís Companys, 23, Local A · 08970',
    'contact.hours': 'Horario',
    'contact.hoursValue': 'Lun–Vie 9:00–18:00',
    'contact.hoursDesc': 'Respuesta garantizada en menos de 24h laborables.',
    'contact.promise': 'Respuesta en menos de 24 horas',
    'contact.promiseDesc': 'Te contactamos para analizar tu negocio y diseñar la solución a medida. Sin compromiso.',
    'contact.ctaTitle': '¿Prefieres que te llamemos nosotros?',
    'contact.ctaDesc': 'Solicita una demo gratuita y descubre cómo SmartPOS puede transformar tu negocio.',
    'contact.ctaBtn': 'Solicitar demo gratis',

    // About

    // Guía TPV
    'guia.eyebrow': 'Guía',
    'guia.title1': 'Cómo elegir el mejor',
    'guia.title2': 'software TPV en España',
    'guia.desc': 'Los factores clave que debes considerar al elegir un punto de venta en 2026: nube, cumplimiento fiscal, integraciones e inteligencia artificial.',
    'guia.readTime': '5 min de lectura',
    'guia.intro': 'Elegir un software de punto de venta (TPV) es una de las decisiones tecnológicas más importantes para cualquier establecimiento físico. Un buen sistema TPV no solo procesa ventas: gestiona el inventario, controla la caja, genera informes, cumple con la normativa fiscal y se integra con los canales de venta online. En esta guía explicamos los factores clave que debes considerar al elegir un TPV en España en 2026.',
    'guia.s1Title': 'Software en la nube vs. local',
    'guia.s1Text': 'Un TPV en la nube permite acceder a tus datos desde cualquier dispositivo y sincronizar varios establecimientos en tiempo real. Sin embargo, es esencial que funcione también en modo offline: si se cae la conexión, el sistema debe seguir registrando ventas y sincronizar automáticamente al recuperar la red. Los sistemas híbridos combinan lo mejor de ambos mundos.',
    'guia.s2Title': 'Cumplimiento fiscal: VeriFactu',
    'guia.s2Text': 'Desde 2025, los sistemas de facturación en España deben cumplir con la normativa VeriFactu, que obliga a enviar facturas simplificadas a la AEAT de forma automática. Un TPV que no esté adaptado puede generar sanciones y problemas con Hacienda. Verifica que el sistema emite y firma electrónicamente los tickets y los envía a la AEAT sin intervención manual.',
    'guia.s3Title': 'Integraciones y canales de venta',
    'guia.s3Text': 'El TPV debe conectarse con los servicios que ya usas: pasarelas de pago, plataformas de delivery, ERPs, CRMs y e-commerce. Cuantas más integraciones nativas ofrezca, menos fricción habrá en tu operativa diaria. Además, los canales de venta online —carta digital QR, order & pay, click & collect, delivery y takeaway— deben gestionarse desde el mismo panel que las ventas presenciales para tener una visión unificada del negocio.',
    'guia.s4Title': 'Informes, IA y toma de decisiones',
    'guia.s4Text': 'Un TPV moderno no se limita a registrar ventas: analiza los datos y ayuda a tomar decisiones. Los mejores sistemas incorporan inteligencia artificial para predecir la demanda, recomendar promociones, detectar descuadres y optimizar el margen. Busca un sistema que ofrezca informes en tiempo real, alertas automáticas y un panel consolidado para gestionar múltiples establecimientos desde una sola pantalla.',
    'guia.conclusion': 'Conclusión',
    'guia.conclusionText': 'El software TPV ideal para un establecimiento en España debe ser cloud con modo offline, cumplir VeriFactu, integrarse con tus servicios y ofrecer analítica avanzada con IA. SmartPOS reúne todas estas capacidades en un único ecosistema, con hardware propio, respuesta en menos de 24h y planes sin permanencia.',
    'guia.checklist1': 'Cloud híbrido con sincronización automática',
    'guia.checklist2': 'Cumplimiento VeriFactu',
    'guia.checklist3': 'Integraciones con delivery, ERP y e-commerce',
    'guia.checklist4': 'IA aplicada a ventas y gestión',
    'guia.cta': 'Probar SmartPOS gratis',

    // Pricing
    'pricing.eyebrow': 'Planes y precios',
    'pricing.title1': 'Precios',
    'pricing.titleHighlight': 'transparentes',
    'pricing.titleEnd': ', sin sorpresas',
    'pricing.desc': 'Sin permanencia. Sin costes ocultos. El precio exacto se confirma en tu demo personalizada según hardware y servicios.',
    'pricing.badge': 'Más popular',
    'pricing.starter.target': '1 establecimiento · Para empezar',
    'pricing.starter.price': 'desde 49€',
    'pricing.starter.period': '/mes',
    'pricing.starter.f1': 'Software HIOPOS Cloud',
    'pricing.starter.f2': '1 terminal TPV',
    'pricing.starter.f3': 'Carta digital QR',
    'pricing.starter.f4': 'Respuesta en menos de 24h por email',
    'pricing.starter.f5': 'Cumplimiento VeriFactu',
    'pricing.starter.f6': 'Informes básicos de ventas',
    'pricing.starter.cta': 'Solicitar Starter',
    'pricing.business.target': '1-5 establecimientos · Para crecer',
    'pricing.business.price': 'desde 89€',
    'pricing.business.period': '/mes',
    'pricing.business.f1': 'Todo lo de Starter',
    'pricing.business.f2': 'Hasta 5 terminales',
    'pricing.business.f3': 'Multi-establecimiento',
    'pricing.business.f4': 'Pedidos online + delivery',
    'pricing.business.f5': 'CashDro integrado',
    'pricing.business.f6': 'Respuesta prioritaria en menos de 24h',
    'pricing.business.f7': 'Informes avanzados + IA',
    'pricing.business.cta': 'Solicitar Business',
    'pricing.enterprise.target': '+20 establecimientos · Franquicias',
    'pricing.enterprise.price': 'A medida',
    'pricing.enterprise.f1': 'Todo lo de Business',
    'pricing.enterprise.f2': 'Terminales ilimitados',
    'pricing.enterprise.f3': 'Quioscos de autoservicio',
    'pricing.enterprise.f4': 'API e integraciones a medida',
    'pricing.enterprise.f5': 'Gestor de cuenta dedicado',
    'pricing.enterprise.f6': 'Formación continua',
    'pricing.enterprise.f7': 'SLA garantizado por contrato',
    'pricing.enterprise.cta': 'Hablar con ventas',
    'pricing.footerNote': 'Todos los planes incluyen · Respuesta en menos de 24h · Actualizaciones gratuitas · Sin permanencia · Cumplimiento VeriFactu',
    'pricing.upgradesEyebrow': 'Mejora tu plan',
    'pricing.upgradesTitle1': 'Soluciones y',
    'pricing.upgradesTitleHighlight': 'upgrades',
    'pricing.upgradesTitleEnd': 'integrables',
    'pricing.upgradesDesc': 'Añade lo que tu negocio necesite. Todo conectado al ecosistema SmartPOS.',
    'pricing.tag.cajon': 'Cajón',
    'pricing.tag.pagos': 'Pagos',
    'pricing.tag.terminal': 'Terminal',
    'pricing.tag.autoservicio': 'Autoservicio',
    'pricing.tag.hardware': 'Hardware',
    'pricing.viewSolution': 'Ver solución',
    'pricing.upgrade.datfono': 'Datáfono integrado',
    'pricing.upgrade.pack': 'Pack TPV',

    // Lead form
    'lead.sector.hospitality': 'Hostelería',
    'lead.sector.retail': 'Retail',
    'lead.sector.food': 'Alimentación',
    'lead.sector.beauty': 'Belleza',
    'lead.sector.fashion': 'Moda',
    'lead.sector.other': 'Otro',
    'lead.product.software': 'Software TPV',
    'lead.product.hardware': 'Hardware táctil',
    'lead.product.cashdro': 'Cajón CashDro',
    'lead.product.kiosk': 'Quiosco autoservicio',
    'lead.product.menu': 'Carta digital',
    'lead.product.orders': 'Pedidos online',

    // Google Reviews
    'reviews.eyebrow': 'Reseñas reales',
    'reviews.title1': 'Lo que dicen nuestros clientes en',
    'reviews.titleHighlight': 'Google',
    'reviews.desc': 'Algunas de las reseñas que nuestros clientes han compartido públicamente en Google.',
    'reviews.viewAll': 'Ver todas las reseñas en Google',

    // How it works
    'how.eyebrow': 'Cómo funciona',
    'how.title1': 'De la idea a la venta en',
    'how.titleHighlight': 'menos de 48h',
    'how.desc': 'Un proceso sencillo y guiado. Tú pones el negocio, nosotros la tecnología.',
    'how.s1Title': '1. Hablamos',
    'how.s1Duration': '15 min',
    'how.s1Desc': 'Un experto SmartPOS analiza tu negocio, sector y necesidades. Sin compromiso ni tecnicismos: solo consejos útiles.',
    'how.s2Title': '2. Configuramos',
    'how.s2Duration': '24 horas',
    'how.s2Desc': 'Instalamos y personalizamos el software, hardware y dispositivos de pago. Cargamos tu carta, stock y empleados.',
    'how.s3Title': '3. Formamos a tu equipo',
    'how.s3Duration': '1 sesión',
    'how.s3Desc': 'Formación práctica a tu personal para que dominen el TPV, cobros y reportes desde el primer día.',
    'how.s4Title': '4. Vendes más',
    'how.s4Duration': 'Para siempre',
    'how.s4Desc': 'Operativo y con respuesta en menos de 24h. Solo te preocupas de vender; nosotros nos encargamos del resto.',
  },
  EN: {
    'nav.solutions': 'Solutions',
    'nav.sectors': 'Sectors',
    'nav.verifactu': 'VeriFactu',
    'nav.success': 'Success Stories',
    'nav.software': 'POS Software',
    'nav.hardware': 'Hardware',
    'nav.cashdro': 'Smart Drawers',
    'nav.kiosks': 'Kiosks',
    'nav.channels': 'Sales Channels',
    'nav.payments': 'Payment Methods',
    'nav.hospitality': 'Hospitality',
    'nav.retail': 'Retail',
    'nav.food': 'Food',
    'nav.beauty': 'Beauty',
    'nav.franchises': 'Chains & Franchises',
    'nav.demo': 'Free Demo',
    'nav.clientArea': 'Client Area',
    'nav.configurator': 'Configurator',
    'nav.analytics': 'Analytics',
    'nav.hioffice': 'HIOffice',
    'nav.support': 'Technical support',
    'nav.manuals': 'Manuals',
    'nav.logout': 'Log out',
    'nav.tryFree': 'Try it free',
    'nav.skipContent': 'Skip to content',
    'nav.mainNav': 'Main navigation',
    'nav.selectLanguage': 'Select language',
    'nav.userMenu': 'User menu',
    'nav.openMenu': 'Open menu',
    'nav.closeMenu': 'Close menu',
    'nav.pricing': 'Pricing',
    'nav.home': 'Go to homepage',

    'hero.title': 'POS to take your business to the next level',
    'hero.desc2': 'The most complete ecosystem to sell more and manage better.',
    'hero.for': 'For',
    'hero.stats.businesses': 'active businesses',
    'hero.stats.uptime': 'guaranteed uptime',
    'hero.stats.sales': 'sales increase',
    'hero.stats.cash': 'cash discrepancies',
    'sectors.fashion.name': 'Fashion',
    'sectors.shoes.name': 'Shoe shops',
    'sectors.chains.name': 'Chains',
    'sectors.franchises.name': 'Franchises',

    'hero.discoverMore': 'Discover more',

    'footer.tagline': 'The best management solution for your business:',
    'footer.taglineHighlight': 'AI, software, ecommerce, smart drawers, kiosks and integrated services',
    'footer.taglineEnd': 'so you grow more and better!',
    'footer.solutions': 'Solutions',
    'footer.software': 'POS Software',
    'footer.hardware': 'Touch Hardware',
    'footer.cashdro': 'CashDro',
    'footer.kiosks': 'Kiosks',
    'footer.verifactu': 'VeriFactu',
    'footer.configurator': 'Configurator',
    'footer.sectors': 'Sectors',
    'footer.hospitality': 'Hospitality',
    'footer.retail': 'Retail',
    'footer.food': 'Food',
    'footer.beauty': 'Beauty',
    'footer.franchises': 'Chains & Franchises',
    'footer.contact': 'Contact',
    'footer.rights': 'All rights reserved.',
    'footer.about': 'About Us',
    'footer.blog': 'Blog',
    'footer.pricing': 'Pricing',
    'footer.guide': 'POS Guide',
    'footer.privacy': 'Privacy',
    'footer.cookies': 'Cookies',
    'footer.legal': 'Legal Notice',
    'footer.freeDemo': 'Free Demo',

    'contact.eyebrow': 'Contact',
    'contact.title1': "Let's talk about your",
    'contact.title2': 'next project',
    'contact.desc': 'Want to see SmartPOS in action? Request a personalized, no-obligation demo. Our team will contact you to analyze your business and design a tailored solution.',
    'contact.phone': 'Phone',
    'contact.phoneDesc': 'Call us and speak directly with our sales team.',
    'contact.email': 'Email',
    'contact.emailDesc': 'Write to us and we respond in less than 24 hours.',
    'contact.office': 'Office',
    'contact.officeDesc': 'Av. Lluís Companys, 23, Local A · 08970',
    'contact.hours': 'Hours',
    'contact.hoursValue': 'Mon–Fri 9:00–18:00',
    'contact.hoursDesc': 'Guaranteed response in less than 24 business hours.',
    'contact.promise': 'Response in less than 24 hours',
    'contact.promiseDesc': 'We contact you to analyze your business and design a tailored solution. No obligation.',
    'contact.ctaTitle': 'Prefer we call you?',
    'contact.ctaDesc': 'Request a free demo and discover how SmartPOS can transform your business.',
    'contact.ctaBtn': 'Request free demo',


    'guia.eyebrow': 'Guide',
    'guia.title1': 'How to choose the best',
    'guia.title2': 'POS software in Spain',
    'guia.desc': 'The key factors to consider when choosing a point of sale in 2026: cloud, tax compliance, integrations and artificial intelligence.',
    'guia.readTime': '5 min read',
    'guia.intro': 'Choosing point-of-sale (POS) software is one of the most important technology decisions for any physical establishment. A good POS system does more than process sales: it manages inventory, controls the cash register, generates reports, complies with tax regulations and integrates with online sales channels. In this guide we explain the key factors to consider when choosing a POS in Spain in 2026.',
    'guia.s1Title': 'Cloud vs. local software',
    'guia.s1Text': 'A cloud POS lets you access your data from any device and sync multiple locations in real time. However, it is essential that it also works offline: if the connection drops, the system must keep registering sales and sync automatically when the network is restored. Hybrid systems combine the best of both worlds.',
    'guia.s2Title': 'Tax compliance: VeriFactu',
    'guia.s2Text': 'Since 2025, invoicing systems in Spain must comply with the VeriFactu regulation, which requires sending simplified invoices to the AEAT automatically. A POS that is not adapted can generate penalties and problems with the tax authority. Verify that the system issues and electronically signs receipts and sends them to the AEAT without manual intervention.',
    'guia.s3Title': 'Integrations and sales channels',
    'guia.s3Text': 'The POS must connect with the services you already use: payment gateways, delivery platforms, ERPs, CRMs and e-commerce. The more native integrations it offers, the less friction in your daily operations. In addition, online sales channels —QR digital menu, order & pay, click & collect, delivery and takeaway— should be managed from the same panel as in-person sales for a unified view of the business.',
    'guia.s4Title': 'Reports, AI and decision-making',
    'guia.s4Text': 'A modern POS does more than record sales: it analyzes data and helps make decisions. The best systems incorporate artificial intelligence to predict demand, recommend promotions, detect discrepancies and optimize margin. Look for a system that offers real-time reports, automatic alerts and a consolidated panel to manage multiple locations from a single screen.',
    'guia.conclusion': 'Conclusion',
    'guia.conclusionText': 'The ideal POS software for an establishment in Spain should be cloud with offline mode, comply with VeriFactu, integrate with your services and offer advanced analytics with AI. SmartPOS brings together all these capabilities in a single ecosystem, with its own hardware, response in less than 24h and plans with no permanence.',
    'guia.checklist1': 'Hybrid cloud with automatic synchronization',
    'guia.checklist2': 'VeriFactu compliance',
    'guia.checklist3': 'Integrations with delivery, ERP and e-commerce',
    'guia.checklist4': 'AI applied to sales and management',
    'guia.cta': 'Try SmartPOS free',

    // Pricing
    'pricing.eyebrow': 'Plans & pricing',
    'pricing.title1': 'Transparent',
    'pricing.titleHighlight': 'pricing',
    'pricing.titleEnd': ', no surprises',
    'pricing.desc': 'No permanence. No hidden costs. The exact price is confirmed in your personalized demo based on hardware and services.',
    'pricing.badge': 'Most popular',
    'pricing.starter.target': '1 location · To get started',
    'pricing.starter.price': 'from €49',
    'pricing.starter.period': '/mo',
    'pricing.starter.f1': 'HIOPOS Cloud software',
    'pricing.starter.f2': '1 POS terminal',
    'pricing.starter.f3': 'QR digital menu',
    'pricing.starter.f4': 'Response in less than 24h by email',
    'pricing.starter.f5': 'VeriFactu compliance',
    'pricing.starter.f6': 'Basic sales reports',
    'pricing.starter.cta': 'Request Starter',
    'pricing.business.target': '1-5 locations · To grow',
    'pricing.business.price': 'from €89',
    'pricing.business.period': '/mo',
    'pricing.business.f1': 'Everything in Starter',
    'pricing.business.f2': 'Up to 5 terminals',
    'pricing.business.f3': 'Multi-location',
    'pricing.business.f4': 'Online orders + delivery',
    'pricing.business.f5': 'Integrated CashDro',
    'pricing.business.f6': 'Priority response in less than 24h',
    'pricing.business.f7': 'Advanced reports + AI',
    'pricing.business.cta': 'Request Business',
    'pricing.enterprise.target': '+20 locations · Franchises',
    'pricing.enterprise.price': 'Custom',
    'pricing.enterprise.f1': 'Everything in Business',
    'pricing.enterprise.f2': 'Unlimited terminals',
    'pricing.enterprise.f3': 'Self-service kiosks',
    'pricing.enterprise.f4': 'Custom API and integrations',
    'pricing.enterprise.f5': 'Dedicated account manager',
    'pricing.enterprise.f6': 'Continuous training',
    'pricing.enterprise.f7': 'Contract-guaranteed SLA',
    'pricing.enterprise.cta': 'Talk to sales',
    'pricing.footerNote': 'All plans include · Response in less than 24h · Free updates · No permanence · VeriFactu compliance',
    'pricing.upgradesEyebrow': 'Upgrade your plan',
    'pricing.upgradesTitle1': 'Solutions and',
    'pricing.upgradesTitleHighlight': 'upgrades',
    'pricing.upgradesTitleEnd': 'you can integrate',
    'pricing.upgradesDesc': 'Add what your business needs. Everything connected to the SmartPOS ecosystem.',
    'pricing.tag.cajon': 'Drawer',
    'pricing.tag.pagos': 'Payments',
    'pricing.tag.terminal': 'Terminal',
    'pricing.tag.autoservicio': 'Self-service',
    'pricing.tag.hardware': 'Hardware',
    'pricing.viewSolution': 'View solution',
    'pricing.upgrade.datfono': 'Integrated terminal',
    'pricing.upgrade.pack': 'POS Pack',

    // Lead form
    'lead.sector.hospitality': 'Hospitality',
    'lead.sector.retail': 'Retail',
    'lead.sector.food': 'Food',
    'lead.sector.beauty': 'Beauty',
    'lead.sector.fashion': 'Fashion',
    'lead.sector.other': 'Other',
    'lead.product.software': 'POS Software',
    'lead.product.hardware': 'Touch hardware',
    'lead.product.cashdro': 'CashDro drawer',
    'lead.product.kiosk': 'Self-service kiosk',
    'lead.product.menu': 'Digital menu',
    'lead.product.orders': 'Online orders',

    // Google Reviews
    'reviews.eyebrow': 'Real reviews',
    'reviews.title1': 'What our customers say on',
    'reviews.titleHighlight': 'Google',
    'reviews.desc': 'Some of the reviews our customers have publicly shared on Google.',
    'reviews.viewAll': 'See all reviews on Google',

    // How it works
    'how.eyebrow': 'How it works',
    'how.title1': 'From idea to sale in',
    'how.titleHighlight': 'less than 48h',
    'how.desc': 'A simple, guided process. You bring the business, we bring the technology.',
    'how.s1Title': '1. We talk',
    'how.s1Duration': '15 min',
    'how.s1Desc': 'A SmartPOS expert analyzes your business, sector and needs. No obligation or jargon: just useful advice.',
    'how.s2Title': '2. We configure',
    'how.s2Duration': '24 hours',
    'how.s2Desc': 'We install and customize the software, hardware and payment devices. We load your menu, stock and staff.',
    'how.s3Title': '3. We train your team',
    'how.s3Duration': '1 session',
    'how.s3Desc': 'Practical training for your staff so they master the POS, payments and reports from day one.',
    'how.s4Title': '4. You sell more',
    'how.s4Duration': 'Forever',
    'how.s4Desc': 'Up and running with response in less than 24h. You just focus on selling; we handle the rest.',
  },
  CA: {
    'nav.solutions': 'Solucions',
    'nav.sectors': 'Sectors',
    'nav.verifactu': 'VeriFactu',
    'nav.success': "Casos d'Èxit",
    'nav.software': 'Software TPV',
    'nav.hardware': 'Hardware',
    'nav.cashdro': 'Calaixos intel·ligents',
    'nav.kiosks': 'Quioscos',
    'nav.channels': 'Canals de venda',
    'nav.payments': 'Mitjans de pagament',
    'nav.hospitality': 'Hostaleria',
    'nav.retail': 'Retail',
    'nav.food': 'Alimentació',
    'nav.beauty': 'Bellesa',
    'nav.franchises': 'Cadenes i Franquícies',
    'nav.demo': 'Demo Gratis',
    'nav.clientArea': 'Àrea de Client',
    'nav.configurator': 'Configurador',
    'nav.analytics': 'Analytics',
    'nav.hioffice': 'HIOffice',
    'nav.support': 'Suport tècnic',
    'nav.manuals': 'Manuals',
    'nav.logout': 'Tancar sessió',
    'nav.tryFree': 'Prova-ho gratis',
    'nav.skipContent': 'Salta al contingut',
    'nav.mainNav': 'Navegació principal',
    'nav.selectLanguage': 'Seleccionar idioma',
    'nav.userMenu': 'Menú de usuari',
    'nav.openMenu': 'Obrir menú',
    'nav.closeMenu': 'Tancar menú',
    'nav.pricing': 'Preus',
    'nav.home': 'Ves a la pàgina d\'inici',

    'hero.title': 'TPV per portar el teu negoci al següent nivell',
    'hero.desc2': "L'ecosistema més complet perquè venguis més i gestis millor.",
    'hero.for': 'Per a',
    'hero.stats.businesses': 'negocis actius',
    'hero.stats.uptime': 'uptime garantit',
    'hero.stats.sales': 'augment de vendes',
    'hero.stats.cash': 'descuadres de caixa',
    'sectors.fashion.name': 'Moda',
    'sectors.shoes.name': 'Sabateries',
    'sectors.chains.name': 'Cadenes',
    'sectors.franchises.name': 'Franquícies',

    'hero.discoverMore': 'Descobreix més',

    'footer.tagline': 'La millor solució de gestió per al teu negoci:',
    'footer.taglineHighlight': 'IA, software, ecommerce, calaixos intel·ligents, quioscos i serveis integrats',
    'footer.taglineEnd': 'perquè creixis més i millor!',
    'footer.solutions': 'Solucions',
    'footer.software': 'Software TPV',
    'footer.hardware': 'Hardware Tàctil',
    'footer.cashdro': 'CashDro',
    'footer.kiosks': 'Quioscos',
    'footer.verifactu': 'VeriFactu',
    'footer.configurator': 'Configurador',
    'footer.sectors': 'Sectors',
    'footer.hospitality': 'Hostaleria',
    'footer.retail': 'Retail',
    'footer.food': 'Alimentació',
    'footer.beauty': 'Bellesa',
    'footer.franchises': 'Cadenes i Franquícies',
    'footer.contact': 'Contacte',
    'footer.rights': 'Tots els drets reservats.',
    'footer.about': 'Sobre Nosaltres',
    'footer.blog': 'Blog',
    'footer.pricing': 'Preus',
    'footer.guide': 'Guia TPV',
    'footer.privacy': 'Privadesa',
    'footer.cookies': 'Cookies',
    'footer.legal': 'Avís Legal',
    'footer.freeDemo': 'Demo Gratuïta',

    'contact.eyebrow': 'Contacte',
    'contact.title1': 'Parlem del teu',
    'contact.title2': 'pròxim projecte',
    'contact.desc': 'Vols veure SmartPOS en acció? Sol·licita una demo personalitzada i sense compromís. El nostre equip et contactarà per analitzar el teu negoci i dissenyar la solució a mida.',
    'contact.phone': 'Telèfon',
    'contact.phoneDesc': "Truca'ns i parla directament amb el nostre equip comercial.",
    'contact.email': 'Email',
    'contact.emailDesc': 'Escriu-nos i et responem en menys de 24 hores.',
    'contact.office': 'Oficina',
    'contact.officeDesc': 'Av. Lluís Companys, 23, Local A · 08970',
    'contact.hours': 'Horari',
    'contact.hoursValue': 'Dl–Dv 9:00–18:00',
    'contact.hoursDesc': 'Resposta garantida en menys de 24h laborables.',
    'contact.promise': 'Resposta en menys de 24 hores',
    'contact.promiseDesc': 'Et contactem per analitzar el teu negoci i dissenyar la solució a mida. Sense compromís.',
    'contact.ctaTitle': 'Prefereixes que et truquem nosaltres?',
    'contact.ctaDesc': 'Sol·licita una demo gratuïta i descobreix com SmartPOS pot transformar el teu negoci.',
    'contact.ctaBtn': 'Sol·licitar demo gratis',


    'guia.eyebrow': 'Guia',
    'guia.title1': 'Com triar el millor',
    'guia.title2': 'software TPV a Espanya',
    'guia.desc': 'Els factors clau que has de considerar al triar un punt de venda el 2026: núvol, compliment fiscal, integracions i intel·ligència artificial.',
    'guia.readTime': '5 min de lectura',
    'guia.intro': "Triar un software de punt de venda (TPV) és una de les decisions tecnològiques més importants per a qualsevol establiment físic. Un bon sistema TPV no només processa vendes: gestiona l'inventari, controla la caixa, genera informes, compleix amb la normativa fiscal i s'integra amb els canals de venda online. En aquesta guia expliquem els factors clau que has de considerar al triar un TPV a Espanya el 2026.",
    'guia.s1Title': 'Software al núvol vs. local',
    'guia.s1Text': "Un TPV al núvol permet accedir a les teves dades des de qualsevol dispositiu i sincronitzar diversos establiments en temps real. Tanmateix, és essencial que funcioni també en mode offline: si es cau la connexió, el sistema ha de seguir registrant vendes i sincronitzar automàticament en recuperar la xarxa. Els sistemes híbrids combinen el millor dels dos móns.",
    'guia.s2Title': 'Cumpliment fiscal: VeriFactu',
    'guia.s2Text': "Des del 2025, els sistemes de facturació a Espanya han de complir amb la normativa VeriFactu, que obliga a enviar factures simplificades a l'AEAT de forma automàtica. Un TPV que no estigui adaptat pot generar sancions i problemes amb Hisenda. Verifica que el sistema emet i signa electrònicament els tiquets i els envia a l'AEAT sense intervenció manual.",
    'guia.s3Title': 'Integracions i canals de venda',
    'guia.s3Text': "El TPV ha de connectar-se amb els serveis que ja utilitzes: passarel·les de pagament, plataformes de delivery, ERPs, CRMs i e-commerce. Com més integracions natives ofereixi, menys fricció hi haurà a la teva operativa diària. A més, els canals de venda online —carta digital QR, order & pay, click & collect, delivery i takeaway— s'han de gestionar des del mateix panell que les vendes presencials per tenir una visió unificada del negoci.",
    'guia.s4Title': 'Informes, IA i presa de decisions',
    'guia.s4Text': "Un TPV modern no es limita a registrar vendes: analitza les dades i ajuda a prendre decisions. Els millors sistemes incorporen intel·ligència artificial per predir la demanda, recomanar promocions, detectar descuadres i optimitzar el marge. Busca un sistema que ofereixi informes en temps real, alertes automàtiques i un panell consolidat per gestionar diversos establiments des d'una sola pantalla.",
    'guia.conclusion': 'Conclusió',
    'guia.conclusionText': "El software TPV ideal per a un establiment a Espanya ha de ser cloud amb mode offline, complir VeriFactu, integrar-se amb els teus serveis i oferir analítica avançada amb IA. SmartPOS reuneix totes aquestes capacitats en un únic ecosistema, amb hardware propi, resposta en menys de 24h i plans sense permanència.",
    'guia.checklist1': 'Cloud híbrid amb sincronització automàtica',
    'guia.checklist2': 'Cumpliment VeriFactu',
    'guia.checklist3': 'Integracions amb delivery, ERP i e-commerce',
    'guia.checklist4': 'IA aplicada a vendes i gestió',
    'guia.cta': 'Provar SmartPOS gratis',

    // Pricing
    'pricing.eyebrow': 'Plans i preus',
    'pricing.title1': 'Preus',
    'pricing.titleHighlight': 'transparents',
    'pricing.titleEnd': ', sense sorpreses',
    'pricing.desc': 'Sense permanència. Sense costos ocults. El preu exacte es confirma a la teva demo personalitzada segons hardware i serveis.',
    'pricing.badge': 'Més popular',
    'pricing.starter.target': '1 establiment · Per començar',
    'pricing.starter.price': 'des de 49€',
    'pricing.starter.period': '/mes',
    'pricing.starter.f1': 'Software HIOPOS Cloud',
    'pricing.starter.f2': '1 terminal TPV',
    'pricing.starter.f3': 'Carta digital QR',
    'pricing.starter.f4': 'Resposta en menys de 24h per email',
    'pricing.starter.f5': 'Cumpliment VeriFactu',
    'pricing.starter.f6': 'Informes bàsics de vendes',
    'pricing.starter.cta': 'Sol·licita Starter',
    'pricing.business.target': '1-5 establiments · Per créixer',
    'pricing.business.price': 'des de 89€',
    'pricing.business.period': '/mes',
    'pricing.business.f1': 'Tot el de Starter',
    'pricing.business.f2': 'Fins a 5 terminals',
    'pricing.business.f3': 'Multi-establiment',
    'pricing.business.f4': 'Comandes online + delivery',
    'pricing.business.f5': 'CashDro integrat',
    'pricing.business.f6': 'Resposta prioritària en menys de 24h',
    'pricing.business.f7': 'Informes avançats + IA',
    'pricing.business.cta': 'Sol·licita Business',
    'pricing.enterprise.target': '+20 establiments · Franquícies',
    'pricing.enterprise.price': 'A mida',
    'pricing.enterprise.f1': 'Tot el de Business',
    'pricing.enterprise.f2': 'Terminals il·limitats',
    'pricing.enterprise.f3': "Quioscos d'autoservei",
    'pricing.enterprise.f4': 'API i integracions a mida',
    'pricing.enterprise.f5': 'Gestor de compte dedicat',
    'pricing.enterprise.f6': 'Formació contínua',
    'pricing.enterprise.f7': 'SLA garantit per contracte',
    'pricing.enterprise.cta': 'Parlar amb vendes',
    'pricing.footerNote': 'Tots els plans inclouen · Resposta en menys de 24h · Actualitzacions gratuïtes · Sense permanència · Cumpliment VeriFactu',
    'pricing.upgradesEyebrow': 'Millora el teu pla',
    'pricing.upgradesTitle1': 'Solucions i',
    'pricing.upgradesTitleHighlight': 'upgrades',
    'pricing.upgradesTitleEnd': 'integrables',
    'pricing.upgradesDesc': "Afegeix el que el teu negoci necessiti. Tot connectat a l'ecosistema SmartPOS.",
    'pricing.tag.cajon': 'Calaix',
    'pricing.tag.pagos': 'Pagaments',
    'pricing.tag.terminal': 'Terminal',
    'pricing.tag.autoservicio': 'Autoservei',
    'pricing.tag.hardware': 'Hardware',
    'pricing.viewSolution': 'Veure solució',
    'pricing.upgrade.datfono': 'Datàfon integrat',
    'pricing.upgrade.pack': 'Pack TPV',

    // Lead form
    'lead.sector.hospitality': 'Hostaleria',
    'lead.sector.retail': 'Retail',
    'lead.sector.food': 'Alimentació',
    'lead.sector.beauty': 'Bellesa',
    'lead.sector.fashion': 'Moda',
    'lead.sector.other': 'Altre',
    'lead.product.software': 'Software TPV',
    'lead.product.hardware': 'Hardware tàctil',
    'lead.product.cashdro': 'Calaix CashDro',
    'lead.product.kiosk': "Quiosco d'autoservei",
    'lead.product.menu': 'Carta digital',
    'lead.product.orders': 'Comandes online',

    // Google Reviews
    'reviews.eyebrow': 'Ressenyes reals',
    'reviews.title1': 'El que diuen els nostres clients a',
    'reviews.titleHighlight': 'Google',
    'reviews.desc': "Algunes de les ressenyes que els nostres clients han compartit públicament a Google.",
    'reviews.viewAll': 'Veure totes les ressenyes a Google',

    // How it works
    'how.eyebrow': 'Com funciona',
    'how.title1': 'De la idea a la venda en',
    'how.titleHighlight': 'menys de 48h',
    'how.desc': 'Un procés senzill i guiat. Tu poses el negoci, nosaltres la tecnologia.',
    'how.s1Title': '1. Parlem',
    'how.s1Duration': '15 min',
    'how.s1Desc': "Un expert SmartPOS analitza el teu negoci, sector i necessitats. Sense compromís ni tecnicismes: només consells útils.",
    'how.s2Title': '2. Configurem',
    'how.s2Duration': '24 hores',
    'how.s2Desc': "Instal·lem i personalitzem el software, hardware i dispositius de pagament. Carreguem la teva carta, stock i empleats.",
    'how.s3Title': '3. Formem el teu equip',
    'how.s3Duration': '1 sessió',
    'how.s3Desc': 'Formació pràctica al teu personal perquè dominin el TPV, cobraments i informes des del primer dia.',
    'how.s4Title': '4. Vens més',
    'how.s4Duration': 'Per sempre',
    'how.s4Desc': "Operatiu i amb resposta en menys de 24h. Només et preocupes de vendre; nosaltres ens encarreguem de la resta.",
  },
  FR: {
    'nav.solutions': 'Solutions',
    'nav.sectors': 'Secteurs',
    'nav.verifactu': 'VeriFactu',
    'nav.success': 'Témoignages',
    'nav.software': 'Logiciel TPV',
    'nav.hardware': 'Matériel',
    'nav.cashdro': 'Tiroirs intelligents',
    'nav.kiosks': 'Kiosques',
    'nav.channels': 'Canaux de vente',
    'nav.payments': 'Moyens de paiement',
    'nav.hospitality': 'Hôtellerie',
    'nav.retail': 'Retail',
    'nav.food': 'Alimentation',
    'nav.beauty': 'Beauté',
    'nav.franchises': 'Chaînes et Franchises',
    'nav.demo': 'Démo Gratuite',
    'nav.clientArea': 'Espace Client',
    'nav.configurator': 'Configurateur',
    'nav.analytics': 'Analytics',
    'nav.hioffice': 'HIOffice',
    'nav.support': 'Support technique',
    'nav.manuals': 'Manuels',
    'nav.logout': 'Déconnexion',
    'nav.tryFree': 'Essayez gratuitement',
    'nav.skipContent': 'Aller au contenu',
    'nav.mainNav': 'Navigation principale',
    'nav.selectLanguage': 'Choisir la langue',
    'nav.userMenu': 'Menu utilisateur',
    'nav.openMenu': 'Ouvrir le menu',
    'nav.closeMenu': 'Fermer le menu',
    'nav.pricing': 'Tarifs',
    'nav.home': 'Aller à la page d\'accueil',

    'hero.title': 'TPV pour passer votre entreprise au niveau supérieur',
    'hero.desc2': "L'écosystème le plus complet pour vendre plus et mieux gérer.",
    'hero.for': 'Pour',
    'hero.stats.businesses': 'entreprises actives',
    'hero.stats.uptime': 'uptime garanti',
    'hero.stats.sales': 'augmentation des ventes',
    'hero.stats.cash': 'écarts de caisse',
    'sectors.fashion.name': 'Mode',
    'sectors.shoes.name': 'Chaussures',
    'sectors.chains.name': 'Chaînes',
    'sectors.franchises.name': 'Franchises',

    'hero.discoverMore': 'Découvrir plus',

    'footer.tagline': 'La meilleure solution de gestion pour votre entreprise :',
    'footer.taglineHighlight': 'IA, logiciel, e-commerce, tiroirs intelligents, kiosques et services intégrés',
    'footer.taglineEnd': 'pour grandir plus et mieux !',
    'footer.solutions': 'Solutions',
    'footer.software': 'Logiciel TPV',
    'footer.hardware': 'Matériel Tactile',
    'footer.cashdro': 'CashDro',
    'footer.kiosks': 'Kiosques',
    'footer.verifactu': 'VeriFactu',
    'footer.configurator': 'Configurateur',
    'footer.sectors': 'Secteurs',
    'footer.hospitality': 'Hôtellerie',
    'footer.retail': 'Retail',
    'footer.food': 'Alimentation',
    'footer.beauty': 'Beauté',
    'footer.franchises': 'Chaînes et Franchises',
    'footer.contact': 'Contact',
    'footer.rights': 'Tous droits réservés.',
    'footer.about': 'À propos',
    'footer.blog': 'Blog',
    'footer.pricing': 'Tarifs',
    'footer.guide': 'Guide TPV',
    'footer.privacy': 'Confidentialité',
    'footer.cookies': 'Cookies',
    'footer.legal': 'Mentions légales',
    'footer.freeDemo': 'Démo Gratuite',

    'contact.eyebrow': 'Contact',
    'contact.title1': 'Parlons de votre',
    'contact.title2': 'prochain projet',
    'contact.desc': 'Vous voulez voir SmartPOS en action ? Demandez une démo personnalisée et sans engagement. Notre équipe vous contactera pour analyser votre entreprise et concevoir une solution sur mesure.',
    'contact.phone': 'Téléphone',
    'contact.phoneDesc': 'Appelez-nous et parlez directement avec notre équipe commerciale.',
    'contact.email': 'Email',
    'contact.emailDesc': 'Écrivez-nous et nous répondons en moins de 24 heures.',
    'contact.office': 'Bureau',
    'contact.officeDesc': 'Av. Lluís Companys, 23, Local A · 08970',
    'contact.hours': 'Horaires',
    'contact.hoursValue': 'Lun–Ven 9:00–18:00',
    'contact.hoursDesc': 'Réponse garantie en moins de 24h ouvrées.',
    'contact.promise': 'Réponse en moins de 24 heures',
    'contact.promiseDesc': 'Nous vous contactons pour analyser votre entreprise et concevoir une solution sur mesure. Sans engagement.',
    'contact.ctaTitle': 'Préférez-vous que nous vous appelions ?',
    'contact.ctaDesc': 'Demandez une démo gratuite et découvrez comment SmartPOS peut transformer votre entreprise.',
    'contact.ctaBtn': 'Demander une démo gratuite',


    'guia.eyebrow': 'Guide',
    'guia.title1': 'Comment choisir le meilleur',
    'guia.title2': 'logiciel TPV en Espagne',
    'guia.desc': 'Les facteurs clés à considérer pour choisir un point de vente en 2026 : cloud, conformité fiscale, intégrations et intelligence artificielle.',
    'guia.readTime': '5 min de lecture',
    'guia.intro': "Choisir un logiciel de point de vente (TPV) est l'une des décisions technologiques les plus importantes pour tout établissement physique. Un bon système TPV ne fait pas qu'enregistrer les ventes : il gère les stocks, contrôle la caisse, génère des rapports, respecte la réglementation fiscale et s'intègre aux canaux de vente en ligne. Dans ce guide, nous expliquons les facteurs clés à considérer pour choisir un TPV en Espagne en 2026.",
    'guia.s1Title': 'Logiciel cloud vs. local',
    'guia.s1Text': "Un TPV cloud permet d'accéder à vos données depuis n'importe quel appareil et de synchroniser plusieurs établissements en temps réel. Cependant, il est essentiel qu'il fonctionne aussi hors ligne : si la connexion tombe, le système doit continuer à enregistrer les ventes et se synchroniser automatiquement dès que le réseau est rétabli. Les systèmes hybrides combinent le meilleur des deux mondes.",
    'guia.s2Title': 'Conformité fiscale : VeriFactu',
    'guia.s2Text': "Depuis 2025, les systèmes de facturation en Espagne doivent se conformer à la réglementation VeriFactu, qui oblige à envoyer les factures simplifiées à l'AEAT automatiquement. Un TPV non adapté peut générer des sanctions et des problèmes avec le fisc. Vérifiez que le système émet et signe électroniquement les tickets et les envoie à l'AEAT sans intervention manuelle.",
    'guia.s3Title': 'Intégrations et canaux de vente',
    'guia.s3Text': "Le TPV doit se connecter aux services que vous utilisez déjà : passerelles de paiement, plateformes de livraison, ERP, CRM et e-commerce. Plus il offre d'intégrations natives, moins il y a de friction dans vos opérations quotidiennes. De plus, les canaux de vente en ligne —menu digital QR, order & pay, click & collect, delivery et takeaway— doivent être gérés depuis le même panneau que les ventes en présentiel pour une vue unifiée de l'entreprise.",
    'guia.s4Title': 'Rapports, IA et prise de décision',
    'guia.s4Text': "Un TPV moderne ne se limite pas à enregistrer les ventes : il analyse les données et aide à prendre des décisions. Les meilleurs systèmes intègrent l'intelligence artificielle pour prévoir la demande, recommander des promotions, détecter les écarts et optimiser la marge. Cherchez un système qui offre des rapports en temps réel, des alertes automatiques et un panneau consolidé pour gérer plusieurs établissements depuis un seul écran.",
    'guia.conclusion': 'Conclusion',
    'guia.conclusionText': "Le logiciel TPV idéal pour un établissement en Espagne doit être cloud avec mode hors ligne, conforme à VeriFactu, intégré à vos services et offrir une analytique avancée avec IA. SmartPOS réunit toutes ces capacités dans un seul écosystème, avec son propre matériel, une réponse en moins de 24h et des formules sans engagement.",
    'guia.checklist1': 'Cloud hybride avec synchronisation automatique',
    'guia.checklist2': 'Conformité VeriFactu',
    'guia.checklist3': 'Intégrations avec livraison, ERP et e-commerce',
    'guia.checklist4': 'IA appliquée aux ventes et à la gestion',
    'guia.cta': 'Essayer SmartPOS gratuitement',

    // Pricing
    'pricing.eyebrow': 'Formules et tarifs',
    'pricing.title1': 'Tarifs',
    'pricing.titleHighlight': 'transparents',
    'pricing.titleEnd': ', sans surprises',
    'pricing.desc': "Sans engagement. Sans coûts cachés. Le prix exact est confirmé lors de votre démo personnalisée selon le matériel et les services.",
    'pricing.badge': 'Le plus populaire',
    'pricing.starter.target': '1 établissement · Pour démarrer',
    'pricing.starter.price': 'dès 49€',
    'pricing.starter.period': '/mois',
    'pricing.starter.f1': 'Logiciel HIOPOS Cloud',
    'pricing.starter.f2': '1 terminal TPV',
    'pricing.starter.f3': 'Menu digital QR',
    'pricing.starter.f4': 'Réponse en moins de 24h par email',
    'pricing.starter.f5': 'Conformité VeriFactu',
    'pricing.starter.f6': 'Rapports de ventes de base',
    'pricing.starter.cta': 'Demander Starter',
    'pricing.business.target': '1-5 établissements · Pour grandir',
    'pricing.business.price': 'dès 89€',
    'pricing.business.period': '/mois',
    'pricing.business.f1': 'Tout Starter',
    'pricing.business.f2': "Jusqu'à 5 terminaux",
    'pricing.business.f3': 'Multi-établissements',
    'pricing.business.f4': 'Commandes en ligne + livraison',
    'pricing.business.f5': 'CashDro intégré',
    'pricing.business.f6': 'Réponse prioritaire en moins de 24h',
    'pricing.business.f7': 'Rapports avancés + IA',
    'pricing.business.cta': 'Demander Business',
    'pricing.enterprise.target': '+20 établissements · Franchises',
    'pricing.enterprise.price': 'Sur mesure',
    'pricing.enterprise.f1': 'Tout Business',
    'pricing.enterprise.f2': 'Terminaux illimités',
    'pricing.enterprise.f3': 'Kiosques en libre-service',
    'pricing.enterprise.f4': 'API et intégrations sur mesure',
    'pricing.enterprise.f5': 'Gestionnaire de compte dédié',
    'pricing.enterprise.f6': 'Formation continue',
    'pricing.enterprise.f7': 'SLA garanti par contrat',
    'pricing.enterprise.cta': 'Parler aux ventes',
    'pricing.footerNote': 'Toutes les formules incluent · Réponse en moins de 24h · Mises à jour gratuites · Sans engagement · Conformité VeriFactu',
    'pricing.upgradesEyebrow': 'Améliorez votre formule',
    'pricing.upgradesTitle1': 'Solutions et',
    'pricing.upgradesTitleHighlight': 'extensions',
    'pricing.upgradesTitleEnd': 'intégrables',
    'pricing.upgradesDesc': "Ajoutez ce dont votre entreprise a besoin. Tout connecté à l'écosystème SmartPOS.",
    'pricing.tag.cajon': 'Tiroir',
    'pricing.tag.pagos': 'Paiements',
    'pricing.tag.terminal': 'Terminal',
    'pricing.tag.autoservicio': 'Libre-service',
    'pricing.tag.hardware': 'Matériel',
    'pricing.viewSolution': 'Voir la solution',
    'pricing.upgrade.datfono': 'Terminal intégré',
    'pricing.upgrade.pack': 'Pack TPV',

    // Lead form
    'lead.sector.hospitality': 'Hôtellerie',
    'lead.sector.retail': 'Retail',
    'lead.sector.food': 'Alimentation',
    'lead.sector.beauty': 'Beauté',
    'lead.sector.fashion': 'Mode',
    'lead.sector.other': 'Autre',
    'lead.product.software': 'Logiciel TPV',
    'lead.product.hardware': 'Matériel tactile',
    'lead.product.cashdro': 'Tiroir CashDro',
    'lead.product.kiosk': 'Kiosque libre-service',
    'lead.product.menu': 'Menu digital',
    'lead.product.orders': 'Commandes en ligne',

    // Google Reviews
    'reviews.eyebrow': 'Avis réels',
    'reviews.title1': 'Ce que nos clients disent sur',
    'reviews.titleHighlight': 'Google',
    'reviews.desc': "Quelques-uns des avis que nos clients ont partagés publiquement sur Google.",
    'reviews.viewAll': 'Voir tous les avis sur Google',

    // How it works
    'how.eyebrow': 'Comment ça marche',
    'how.title1': "De l'idée à la vente en",
    'how.titleHighlight': 'moins de 48h',
    'how.desc': 'Un processus simple et guidé. Vous apportez le business, nous la technologie.',
    'how.s1Title': '1. On discute',
    'how.s1Duration': '15 min',
    'how.s1Desc': "Un expert SmartPOS analyse votre entreprise, votre secteur et vos besoins. Sans engagement ni jargon : juste des conseils utiles.",
    'how.s2Title': '2. On configure',
    'how.s2Duration': '24 heures',
    'how.s2Desc': 'Nous installons et personnalisons le logiciel, le matériel et les appareils de paiement. Nous chargeons votre menu, stock et employés.',
    'how.s3Title': "3. On forme votre équipe",
    'how.s3Duration': '1 session',
    'how.s3Desc': "Formation pratique pour votre personnel afin qu'il maîtrise le TPV, les paiements et les rapports dès le premier jour.",
    'how.s4Title': '4. Vous vendez plus',
    'how.s4Duration': 'Pour toujours',
    'how.s4Desc': "Opérationnel avec réponse en moins de 24h. Vous vous concentrez sur la vente ; nous gérons le reste.",
  },
};

export const translations = {
  ES: { ...baseTranslations.ES, ...translationsExtra.ES },
  EN: { ...baseTranslations.EN, ...translationsExtra.EN },
  CA: { ...baseTranslations.CA, ...translationsExtra.CA },
  FR: { ...baseTranslations.FR, ...translationsExtra.FR },
};